import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Toggle, FieldError } from '../../core';
import { AddressSelect } from '../../address/AddressSelect';
import { AddressForm } from '../../address/AddressFormikFields';
import { useFormatMessage } from '../../../intl/intlHooks';
import { allAddresses } from '../../../address/addressSelectors';
import { physicalCardFormMessages } from './giftCardMessages';

import {
    ADDRESS_FULLNAME,
    ADDRESS_STREET1,
    ADDRESS_STREET2,
    ADDRESS_CITY,
    ADDRESS_STATE,
    ADDRESS_POSTCODE
} from '../../../address';

import {
    SenderNameField,
    ADDRESS_HASH_KEY
} from '../fields';
import {ExpectAGiftButton} from "./ExpectAGiftButton";

export const InnerPhysicalCardForm = ({
    errors,
    anyTouched,
    addresses,
    addressHashKey,
    setFieldValue,
    isSelfBuy,
    useCardNameField,
    expectAGift,
    setTouched
}) => {
    const formatMessage = useFormatMessage();
    const [isSavedAddress, setIsSavedAddress] = React.useState(Boolean(addressHashKey));
    const [savedAddressKey, setSavedAddressKey] = React.useState(addressHashKey);
    const physicalFields = [ADDRESS_FULLNAME, ADDRESS_STREET1, ADDRESS_STREET2, ADDRESS_CITY, ADDRESS_STATE, ADDRESS_POSTCODE];
    const defaultAddress = savedAddressKey ? addresses.filter((addr) => addr.hashKey === savedAddressKey)[0] : addresses[0];

    const handleSavedAddressChange = useSavedAddress => {
        if (useSavedAddress) {
            setIsSavedAddress(useSavedAddress);
            setSavedAddressKey(defaultAddress.hashKey);
            setFieldValue('isSavedAddress', useSavedAddress);
            setFieldValue('addressHashKey', defaultAddress.hashKey);
            physicalFields.map((field) => setFieldValue(field, defaultAddress[field]));
        } else {
            setIsSavedAddress(useSavedAddress);
            setFieldValue('isSavedAddress', '');
            setFieldValue('addressHashKey', '');
            physicalFields.map((field) => setFieldValue(field, ''));
        }
    };

    const addressBookClickHandler = savedAddress => {
        setFieldValue(ADDRESS_HASH_KEY, savedAddress.hashKey);
        setFieldValue(ADDRESS_FULLNAME, savedAddress[ADDRESS_FULLNAME]);
        setFieldValue(ADDRESS_STREET1, savedAddress[ADDRESS_STREET1]);
        setFieldValue(ADDRESS_STREET2, savedAddress[ADDRESS_STREET2]);
        setFieldValue(ADDRESS_CITY, savedAddress[ADDRESS_CITY]);
        setFieldValue(ADDRESS_STATE, savedAddress[ADDRESS_STATE]);
        setFieldValue(ADDRESS_POSTCODE, savedAddress[ADDRESS_POSTCODE]);
        setSavedAddressKey(savedAddress.hashKey);
    };

    const expectAGiftProps = {
        setTouched,
        setFieldValue,
        expectAGift,
        label: formatMessage(physicalCardFormMessages.expectAGift)
    };

    const isAddressSelected = anyTouched && errors.addressHashKey && isSavedAddress && !savedAddressKey;

    return (
        <React.Fragment>
            {!isSelfBuy && <SenderNameField />}
            {addresses.length > 0 && (
                <Toggle
                    name="isSavedAddress"
                    label={formatMessage(physicalCardFormMessages.usePreviousAddress)}
                    toggleClickHandler={handleSavedAddressChange}
                    initialValue={isSavedAddress}
                />
            )}
            {isSavedAddress ? (
                <AddressSelect
                    addresses={addresses}
                    clickHandler={addressBookClickHandler}
                    selectedHashKey={savedAddressKey}
                />
            ) : (
                <AddressForm
                    isSelfBuy={isSelfBuy}
                    useCardNameField={useCardNameField}
                />
            )}
            {isAddressSelected && <FieldError message={errors.addressHashKey} />}
            {(!isSelfBuy && <ExpectAGiftButton {...expectAGiftProps} />)}
        </React.Fragment>
    );
};
/* eslint-enable */
InnerPhysicalCardForm.defaultProps = {
    errors: {},
    addresses: [],
    addressHashKey: '',
    useCardNameField: false,
};

InnerPhysicalCardForm.propTypes = {
    errors: PropTypes.object,
    anyTouched: PropTypes.bool.isRequired,
    addresses: PropTypes.array,
    addressHashKey: PropTypes.string,
    setFieldValue: PropTypes.func.isRequired,
    isSelfBuy: PropTypes.bool.isRequired,
    useCardNameField: PropTypes.bool,
    expectAGift: PropTypes.bool.isRequired,
    setTouched: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ addresses: allAddresses(state) });

export const PhysicalCardForm = connect(mapStateToProps)(InnerPhysicalCardForm);
